// Estimated reading time — main body only.
// Formula: minutes = ceil(word_count / 200), minimum 1.
// Localised via i18n key `readingTime.label` with {{minutes}}.

const countWords = (input) => {
  if (!input) return 0;
  const text = Array.isArray(input) ? input.filter(Boolean).join(" ") : String(input);
  const stripped = text.replace(/\s+/g, " ").trim();
  if (!stripped) return 0;
  return stripped.split(" ").length;
};

export const estimateMinutes = (input) => {
  const words = countWords(input);
  return Math.max(1, Math.ceil(words / 200));
};

// t is the react-i18next t function
export const formatReadTime = (input, t) => {
  const minutes = estimateMinutes(input);
  return t("readingTime.label", { minutes, defaultValue: `${minutes} min read` });
};
